module.exports = __webpack_public_path__ + "static/media/Background_6.615cd702.svg";